class HomeEntreprise {
  constructor() {
    this.trigger = document.querySelectorAll(
      '[data-trigger="home-entreprise"]'
    );
    this.target = document.querySelector('[data-target="home-entreprise"]');
    this.close = document.querySelectorAll('[data-close="home-entreprise"]');

    if (this.target) {
      this._init();
    }
  }

  _init() {
    for (let element of Array.from(this.target.children)) {
      this._hide(element);
      element.setAttribute("data-state", "closed");
    }
    for (let element of this.trigger) {
      element.addEventListener("click", event =>
        this._toggleNav(Array.from(this.trigger).indexOf(element))
      );
    }
    for (let element of this.close) {
      element.addEventListener("click", event =>
        this._toggleClose(Array.from(this.close).indexOf(element))
      );
    }
  }

  _toggleClose(index) {
    const element = Array.from(this.target.children)[index];
    this._hide(element);
    element.setAttribute("data-state", "closed");
  }

  _toggleNav(index) {
    this._toggleState(
      Array.from(this.target.children),
      index,
      "open",
      "closed"
    );
  }

  _toggleState(elem, index, one, two) {
    for (let element of Array.from(this.target.children)) {
      this._hide(element);
      element.setAttribute("data-state", two);
    }
    this._show(elem[index]);
    elem[index].setAttribute("data-state", one);
  }

  _hide(elem) {
    elem.style.visibility = "hidden";
  }

  _show(elem) {
    elem.style.visibility = "visible";
  }
}

export let homeEntreprise = new HomeEntreprise();
